import React, { useMemo, useState, useEffect } from "react";
import { Input, Typography } from "antd";
import MathText from "../components/MathText"; // import yo'lini loyihangizga moslang

const { Text } = Typography;

/**
 * MathAnswerInput
 * - Foydalanuvchi kiritgan matnni (masalan: "1/2") oldindan ko'rish sifatida MathText bilan render qiladi
 * - Oddiy sintaksislarni avtomatik LaTeX ga o'giradi: a/b, sqrt(...), x^y
 *
 * Props:
 * - value?: string                // ixtiyoriy, controlled holat uchun
 * - onChange?: (val: string) => void
 * - placeholder?: string
 * - autoFocus?: boolean
 * - size?: "small" | "middle" | "large"
 */
export default function MathAnswerInput({
                                            value,
                                            onChange,
                                            placeholder = "Javobni yozing (masalan: 1/2, sqrt(5), x^2)...",
                                            autoFocus = false,
                                            size = "large",
                                        }) {
    const [raw, setRaw] = useState(value ?? "");

    // tashqi value o'zgarsa ichki state-ni sinxronlab turamiz
    useEffect(() => {
        if (value !== undefined && value !== raw) setRaw(value);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [value]);

    const handleChange = (e) => {
        const v = e.target.value;
        setRaw(v);
        onChange?.(v);
    };

    // Oddiy "smart" o'giruvchi: "1/2" -> \frac{1}{2}, sqrt(9) -> \sqrt{9}, x^2 -> x^{2}
    const latex = useMemo(() => {
        const v = (raw || "").trim();

        // fraction: a/b (bo'shliqsiz oddiy ko'rinish)
        const frac = v.match(/^\(?\s*([^\s/()]+)\s*\)?\s*\/\s*\(?\s*([^\s/()]+)\s*\)?$/);
        if (frac) {
            const [, a, b] = frac;
            return `\\frac{${a}}{${b}}`;
        }

        // sqrt(...)
        const sq = v.match(/^sqrt\((.+)\)$/i);
        if (sq) return `\\sqrt{${sq[1]}}`;

        // x^y -> x^{y}
        const pow = v.match(/^(.+)\^(.+)$/);
        if (pow) return `${pow[1]}^{${pow[2]}}`;

        // default: boricha
        return v || "\\,";
    }, [raw]);

    return (
        <div>
            {/* Input + pastki kichik chiziq (underline) */}
            <div
                style={{
                    display: "inline-block",
                    padding: 6,
                    border: "1px solid #d9d9d9",
                    borderRadius: 10,
                }}
            >
                <Input
                    value={raw}
                    onChange={handleChange}
                    placeholder={placeholder}
                    autoFocus={autoFocus}
                    size={size}
                    autoComplete="off"
                    autoCorrect="off"
                    spellCheck={false}
                    variant="borderless"
                    style={{ width: 180 }}
                />
                <div
                    style={{
                        height: 2,
                        background: "#d9d9d9",
                        borderRadius: 2,
                        marginTop: 4,
                    }}
                />
            </div>

            {/* Preview */}
            <div style={{ marginTop: 12, display: "flex", alignItems: "center", gap: 8 }}>
                <Text strong>Answer Preview:</Text>
                <div style={{ fontSize: 20, lineHeight: 1 }}>
                     <MathText
                       key={`preview-${latex}`}
                       text={latex ? `$${latex}$` : ""}
                     />
                </div>
            </div>
        </div>
    );
}